import { BooksHero } from '@/components/books/BooksHero'
import { BooksFeatured } from '@/components/books/BooksFeatured'
import { BooksVolumes } from '@/components/books/BooksVolumes'
import { BooksAuthor } from '@/components/books/BooksAuthor'

export const BooksPage = () => (
  <>
    <BooksHero />
    <BooksFeatured />
    <BooksVolumes />
    <BooksAuthor />
  </>
)
